<template>
  <div data-private class="flex h-full">
    <PageSidebar title="Impact Analytics" :items="sidebarItems" />
    <div class="flex-1 h-full overflow-x-auto bg-gray-100">
      <Impact_Analytics :view="view" :id="id" />
    </div>
  </div>
</template>

<script>
import PageSidebar from '../widgetcomponents/library/PageSidebar.vue';
import Impact_Analytics from './Impact_Analytics.vue';
import { NOTEBOOKS_PATH, FRAMES_PATH } from './impactNav';

export default {
  name: 'ImpactAnalyticsShell',
  components: { PageSidebar, Impact_Analytics },
  props: {
    view: { type: String, default: 'notebooks' },
    id: { type: [Number, String], default: null },
  },
  computed: {
    sidebarItems() {
      return [
        { id: 'impact-notebooks', label: 'Notebooks', to: NOTEBOOKS_PATH },
        { id: 'impact-frames', label: 'Saved frames', to: FRAMES_PATH },
      ];
    },
  },
};
</script>
